import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Button, Col, Row } from 'react-bootstrap';
import { Form, withFormik } from 'formik';
import * as Yup from 'yup';

import '../../services/yupCustomMethods';
import { AccountSection, PeopleSection } from '../Shared';
import CoverSection from './Form/CoverSection';
import { commonValidation, requestQuotationValidation } from './Form/ValidationSchema';

const LeadForm = ({
  errors,
  handleSubmit,
  isSubmitting,
  onHide,
  setFieldValue,
  touched,
  values,
  lead,
  onStep,
  ...props
}) => {
  const { action, fromAdmin, modelUrl, setIsRequested } = props;
  const [submitSchema, setSubmitSchema] = useState(false);
  const history = useHistory();

  const modelName = 'lead';
  const isNew = action === 'new';
  const isNotEdit = action !== 'edit';
  const adminAllowedToEdit = fromAdmin && action === 'edit' && !onStep('oportunity') && !onStep('renewal');
  const submitText = isNotEdit ? 'Solicitar cotización' : 'Guardar cambios';

  const { requested } = values.lead;
  const requiredValues = !isNew || ( isNew && requested );

  const handleCancelButton = () => {
    switch (action) {
      case 'edit':
        onHide();
        break;
      case 'new':
        history.push(modelUrl);
        break;
      case 'requestQuotation':
        history.push(`${modelUrl}/${values.lead.id}`);
        break;
      default:
        break;
    }
  };

  const handleSubmitValues = submitType => {
    const isRequestQuotation = isNew && submitType === 'requestQuotation';
    if (isRequestQuotation) setFieldValue(`${modelName}[requested]`, isRequestQuotation);
    if (isNew) setIsRequested(isRequestQuotation);
    setSubmitSchema(true);
  };

  const handleOnSubmit = () => {
    if (submitSchema) {
      handleSubmit();
      setSubmitSchema(false);
    }
  };

  useEffect(handleOnSubmit, [submitSchema]);

  return (
    <Form>
      {isNotEdit && <AccountSection fromAdmin={fromAdmin} modelName={modelName}/>}

      <CoverSection
        fromAdmin={fromAdmin}
        action={action}
        modelName={modelName}
        requiredValues={requiredValues}
        disabled={adminAllowedToEdit}
      />

      {isNotEdit && (
        <>
          <hr className="w-100 mb-5"/>
          <PeopleSection fromAdmin={fromAdmin} modelName={modelName} requiredValues={requiredValues}/>
        </>
      )}

      <Row className="d-flex align-items-center flex-row-reverse">
        <Col md={4} lg={3} className="mt-4">
          <Button block variant="submit" onClick={() => handleSubmitValues('requestQuotation')} disabled={isSubmitting}>
            {submitText}
          </Button>
        </Col>
        {isNew && (
          <Col md={4} lg={3} className="mt-4">
            <Button block variant="secondary" onClick={() => handleSubmitValues('new')} disabled={isSubmitting}>
              Guardar oportunidad
            </Button>
          </Col>
        )}
        <Col md={4} lg={2} className="mt-4">
          <Button block variant="cancel" onClick={handleCancelButton}>
            Cancelar
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

const setInitialValues = ({ lead }) => ( { lead } );

const validationSchema = ({ action, isRequested, fromAdmin }) => {
  const adminAddedValidation = { executiveManagerId: Yup.string().required('Debes seleccionar un ejecutivo') };
  switch (action) {
    case 'new':
      return Yup.object().shape({
        lead: Yup.object().shape({
          ...( fromAdmin ? adminAddedValidation : {} ),
          ...( isRequested ? requestQuotationValidation : commonValidation ),
        }),
      });
    case 'edit':
      return Yup.object().shape({
        lead: Yup.object().shape({
          ...commonValidation,
          ...( fromAdmin ? adminAddedValidation : {} ),
          coverDetail: Yup.string().required('Debes ingresar un detalle de cobertura'),
        }),
      });
    case 'requestQuotation':
      return Yup.object().shape({
        lead: Yup.object().shape(requestQuotationValidation),
      });
    default:
      return undefined;
  }
};

const handleSubmit = (values, { props, setSubmitting }) => {
  const { formRequest, onHide } = props;
  formRequest(values, setSubmitting);
  if (onHide) onHide();
};

export default withFormik({
  mapPropsToValues: setInitialValues,
  handleSubmit,
  validationSchema,
  enableReinitialize: true,
  validateOnMount: props => props.action !== 'new',
})(LeadForm);
